import React from 'react';
import styles from './employee-mini-card.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { IEmployeeInfo } from 'shared/api/business/interfaces/employee-info.interface';
import { CircleImage } from '../circle-image/circle-image';

export interface IEmployeeMiniCardProps {
  employeeInfo: IEmployeeInfo;
}

export const EmployeeMiniCard: React.FC<IEmployeeMiniCardProps> = ({
  employeeInfo,
}) => {
  const navigate = useNavigate();

  const handleNavigateClick = () => {
    const path = AppLinks.EmployeeLink.replace(':id', String(employeeInfo.id));
    navigate(path);
  };
  return (
    <div
      className={styles.employee_card__container}
      onClick={handleNavigateClick}
    >
      <div className={styles.employee__title}>
        <CircleImage imgSize={35} imgSrc={employeeInfo.imgUrl} />
        <div className={styles.title__name}>{employeeInfo.fio}</div>
      </div>
    </div>
  );
};
